<template lang="pug">
  .form-group.relative
    label.text-normal.bold(v-if='label')
      | {{ label}}
    input.input-border.text-normal.dark-gray(
      :type='type'
      v-model='input'
      :placeholder='placeholder'
      :class='{ error: inputError, filled: input && filled }'
      @input='updateValue'
    )
    button.eye(v-show='showEye' type='button' @click='changeFormat')
      simple-svg.m-right-1.gray-icon.hide-title(
        :filepath='valueHidden ? eyeOffIc : eyeOnIc'
        :width='"20px"'
        :height='"20px"'
      )
</template>

<script>
import eyeOnIc from '@/assets/ic_eye_on.svg'
import eyeOffIc from '@/assets/ic_eye_off.svg'

export default {
  data() {
    return {
      eyeOnIc,
      eyeOffIc,
      input: this.value,
      valueHidden: true
    }
  },
  props: {
    label: { type: String, required: false },
    placeholder: { type: String, default: '' },
    inputError: { type: Boolean, default: false },
    value: { type: String, default: '' },
    name: { type: String, default: 'password' },
    filled: { type: Boolean, required: false }
  },
  computed: {
    showEye() {
      return this.input.length > 0
    },
    type () {
      return this.valueHidden ? 'password' : 'text'
    }
  },
  methods: {
    changeFormat() {
      this.valueHidden = !this.valueHidden
    },
    updateValue() {
      this.$emit('input', this.input, this.name)
    }
  }
}
</script>

<style lang="scss" scoped>
@import '../scss/variables/colors';

.eye {
  bottom: 8px;
  position: absolute;
  right: 0;
}

.input-border:focus {
  border-color: $blue;
}

.filled {
  background-color: $lighter-blue;
}
</style>
